import { render, staticRenderFns } from "./choice-project-type.vue?vue&type=template&id=72d6f722&"
import script from "./choice-project-type.vue?vue&type=script&lang=js&"
export * from "./choice-project-type.vue?vue&type=script&lang=js&"
import style0 from "./choice-project-type.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports